// src/pages/ClaimSupportPage.js
import React, { useState } from "react";
import {
  Typography,
  Card,
  Steps,
  Button,
  List,
  Divider,
  Alert,
  Space,
  Row,
  Col,
} from "antd";
import {
  PhoneOutlined,
  SafetyCertificateOutlined,
  CameraOutlined,
  CarOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { COMPANY, HOTLINE } from "src/constants/constants";

const { Title, Text, Paragraph } = Typography;
const { Step } = Steps;

const claimSteps = [
  {
    id: 1,
    icon: <CarOutlined />,
    title: "Giữ nguyên hiện trường",
    description:
      "Không di chuyển xe nếu không cần thiết và chưa được hướng dẫn từ bảo hiểm hoặc cơ quan chức năng.",
  },
  {
    id: 2,
    icon: <CameraOutlined />,
    title: "Chụp ảnh & ghi nhận thông tin",
    description:
      "Chụp rõ nét hiện trường, biển số xe các bên, giấy tờ liên quan và tổn thất.",
  },
  {
    id: 3,
    icon: <PhoneOutlined />,
    title: "Liên hệ ngay tổng đài",
    description:
      "Gọi hotline để được hướng dẫn chi tiết, cử giám định viên và hỗ trợ nhanh nhất.",
  },
];

const hotlineList = [
  // {
  //   id: 1,
  //   company: "Bảo hiểm ABC",
  //   phone: "1900 1234",
  //   workingTime: "24/7",
  //   is24h: true,
  // },
  {
    id: 2,
    company: COMPANY,
    phone: HOTLINE,
    workingTime: "8:00 – 17:30 (thứ 2–thứ 6)",
    is24h: false,
  },
  // có thể thêm nhiều hơn
];

const ClaimSupportPage = () => {
  const [steps] = useState(claimSteps);
  const [hotlines] = useState(hotlineList);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f7ff 0%, #e6f4ff 100%)",
        padding: "16px",
      }}
    >
      <Row justify="center">
        <Col xs={24} sm={22} md={20} lg={16} xl={14}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            {/* Header + Alert khẩn cấp */}
            <Card
              bordered={false}
              style={{
                borderRadius: 16,
                background: "white",
                boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
                overflow: "hidden",
              }}
            >
              <Space align="center" style={{ marginBottom: 16 }}>
                <SafetyCertificateOutlined
                  style={{ fontSize: 32, color: "#1677ff" }}
                />
                <Title level={3} style={{ margin: 0, color: "#1a3d6e" }}>
                  Hỗ trợ bồi thường tổn thất
                </Title>
              </Space>

              <Alert
                message="Quan trọng: Hãy giữ bình tĩnh và thực hiện đúng 3 bước dưới đây"
                type="info"
                showIcon
                style={{ marginBottom: 24, borderRadius: 12 }}
              />

              <Paragraph style={{ fontSize: 16, color: "#434343" }}>
                Khi xảy ra tai nạn hoặc sự cố, làm theo thứ tự sau để được hỗ trợ
                nhanh và đúng quy trình:
              </Paragraph>

              {/* Steps – vertical, icon lớn hơn */}
              <Steps
                direction="vertical"
                size="small"
                current={-1} // chưa hoàn thành bước nào
                style={{ margin: "32px 0" }}
              >
                {steps.map((step) => (
                  <Step
                    key={step.id}
                    icon={
                      <div
                        style={{
                          fontSize: 24,
                          color: "#1677ff",
                          background: "#e6f4ff",
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {step.icon}
                      </div>
                    }
                    title={
                      <Text strong style={{ fontSize: 17 }}>
                        {step.title}
                      </Text>
                    }
                    description={
                      <Text type="secondary" style={{ fontSize: 15 }}>
                        {step.description}
                      </Text>
                    }
                  />
                ))}
              </Steps>

              <Divider />

              {/* Tổng đài */}
              <Title level={4} style={{ marginBottom: 20, color: "#1a3d6e" }}>
                Tổng đài hỗ trợ 24/7 & giờ hành chính
              </Title>

              <List
                grid={{
                  gutter: 16,
                  xs: 1,
                  sm: 1,
                  md: 1,
                  lg: 1,
                  xl: 1,
                }}
                dataSource={hotlines}
                renderItem={(item) => (
                  <List.Item>
                    <Card
                      hoverable
                      style={{
                        borderRadius: 16,
                        border: item.is24h
                          ? "1px solid #52c41a"
                          : "1px solid #d9d9d9",
                        background: item.is24h ? "#f6ffed" : "white",
                      }}
                    >
                      <Space
                        direction="vertical"
                        style={{ width: "100%" }}
                        size="middle"
                      >
                        <Space align="center">
                          <Text strong style={{ fontSize: 18 }}>
                            {item.company}
                          </Text>
                          {item.is24h && (
                            <ClockCircleOutlined
                              style={{ color: "#52c41a", fontSize: 16 }}
                            />
                          )}
                        </Space>

                        <Text type="secondary">
                          Thời gian: {item.workingTime}
                        </Text>

                        <Button
                          type="primary"
                          size="large"
                          icon={<PhoneOutlined />}
                          href={`tel:${item.phone.replace(/\s/g, "")}`}
                          block
                          style={{
                            height: 52,
                            fontSize: 17,
                            borderRadius: 12,
                            background: item.is24h ? "#52c41a" : "#1677ff",
                            borderColor: item.is24h ? "#52c41a" : "#1677ff",
                          }}
                        >
                          Gọi ngay {item.phone}
                        </Button>
                      </Space>
                    </Card>
                  </List.Item>
                )}
              />

              {/* Footer note */}
              <Divider />
              <Paragraph
                type="secondary"
                style={{ textAlign: "center", fontSize: 14 }}
              >
                Nếu có thể, hãy chụp ảnh hiện trường trước khi di chuyển xe và
                lưu giữ biên bản với các bên liên quan.
              </Paragraph>
            </Card>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default ClaimSupportPage;